import { render, staticRenderFns } from "./homev2.vue?vue&type=template&id=70afe494&scoped=true&"
import script from "./homev2.vue?vue&type=script&lang=js&"
export * from "./homev2.vue?vue&type=script&lang=js&"
import style0 from "./homev2.vue?vue&type=style&index=0&id=70afe494&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70afe494",
  null
  
)

export default component.exports